import SpotDescriptor from '../SpotDescriptor';

const upperCaseFirstLetter = (string: string) => {
  const allLower = string.toLowerCase();
  return `${allLower.charAt(0).toUpperCase()}${allLower.slice(1)}`;
};

const allLevels = ['BEGINNER', 'INTERMEDIATE', 'ADVANCED'];

interface AbilityLevels {
  description: string;
  levels: string[];
  summary: string;
}

interface Props {
  abilityLevels?: AbilityLevels;
}

interface Option {
  name: string;
  value: boolean;
}

const AbilityLevelsSpotDescriptor: React.FC<Props> = ({ abilityLevels }) => {
  const value = allLevels.every((val) => abilityLevels?.levels.includes(val))
    ? 'All Abilities'
    : abilityLevels?.levels.map((level) => upperCaseFirstLetter(level.toLowerCase())).join(' - ');

  const options: Option[] = allLevels.map((level) => ({
    name: upperCaseFirstLetter(level.slice(0, 3)),
    value: abilityLevels?.levels.includes(level) || false,
  }));

  if (abilityLevels?.description && value) {
    return (
      <SpotDescriptor
        kind="Ability Level"
        value={value}
        options={options}
        description={abilityLevels?.description}
      />
    );
  }
  return null;
};

export default AbilityLevelsSpotDescriptor;
